import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { EVENT_NAME } from 'common/constants';
import { useAmplitude } from 'components/AmplitudeProvider';
import {
  getChecksFailedFormatted,
  getFailedChecksReason,
  getPaymentDate
} from 'pages/VendorsTablePage/components/PrintChecks';
import { useAppSelector } from 'store/hooks';
import { amplitudeTracker } from 'utils/AmplitudeTracker';
import { DialogContent } from './DialogContent';
import { labels } from './messages';
import { IconErrorStyle, StyledFailureDialog } from './styled';
import { PrintFailureDialogType } from './types';

export const PrintFailureDialog: FC<PrintFailureDialogType> = ({
  open,
  close
}) => {
  const amplitude = useAmplitude();
  const paymentDate = useAppSelector(getPaymentDate);
  const failedChecks = useAppSelector(getChecksFailedFormatted);
  const intl = useIntl();
  const printDialogTitle =
    failedChecks?.length > 1 ? labels.checksLabel : labels.checkLabel;
  const reason = useAppSelector(getFailedChecksReason);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (failedChecks.length)
      amplitudeTracker(amplitude, EVENT_NAME.PrintChecksFailure, {
        'Fail Print': failedChecks.length
      });
  }, [failedChecks]);

  return (
    <StyledFailureDialog
      dataTestId="print-checks-failure-dialog"
      id="print-checks-failure-dialog"
      open={open}
      handleClose={close}
      disableOverlayClicked
      title={
        <>
          <IconErrorStyle />
          {`${failedChecks?.length} ${intl.formatMessage(
            printDialogTitle
          )} ${intl.formatMessage(labels.printCheckFailedLabel)}`}
        </>
      }
    >
      <DialogContent paymentDate={paymentDate} reason={reason} />
    </StyledFailureDialog>
  );
};
